<template>
   <b-img id="thumb" ref="thumb" class="thumb" v-if="imageName" rounded :alt="alt" />
</template>

<script>
import firebase from "firebase"
export default {
   name: "thumb",
   data: function() {
      return {
         url: null
      };
   },
   props: ['imageName', 'alt'],
   methods: {
      initThumb: function() {
         // Simpele aanpak: probeer eerst thumbnail, dan origineel
         const storageRef = firebase.storage().ref();
         const baseName = this.imageName.replace(/\.[^/.]+$/, "");
         const extension = this.imageName.match(/\.[^/.]+$/)?.[0] || '';
         
         // Thumbnail path (Firebase Extension pattern)
         const thumbnailPath = `images/recipes/${baseName}_200x200${extension}`;
         const originalPath = `images/recipes/${this.imageName}`;
         
         // Probeer eerst thumbnail
         storageRef.child(thumbnailPath).getDownloadURL()
            .then(url => {
               this.url = url;
               const image = this.$refs['thumb'];
               if (image) {
                  image.src = url;
               }
            })
            .catch(() => {
               // Fallback naar origineel
               return storageRef.child(originalPath).getDownloadURL();
            })
            .then(url => {
               if (url && !this.url) {
                  this.url = url;
                  const image = this.$refs['thumb'];
                  if (image) {
                     image.src = url;
                  }
               }
            })
            .catch(error => {
               console.error('[Thumb] Failed to load any image:', error);
            });
      }
   },
   mounted() {
      this.$nextTick( () => {
            this.initThumb()
         }
      )
   }
}
</script>

<style>
.thumb {
   width: 100%;
   height: 100px;
   object-fit: cover;
}
</style>


